import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import firebase from "firebase";
import FieldValue = firebase.firestore.FieldValue;
import { TalesProgramma } from "../../../utils/types/TalesProgramma";

export const addProgramma = createAsyncThunk(
  "programma/add",
  async (programma: TalesProgramma) => {
    try {
      return await db.collection("programma").add({
        ...programma,
        show: `${programma.show}` === "true",
        creationDate: FieldValue.serverTimestamp(),
      });
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Programma non aggiunto, ${e.message}`);
    }
  },
);
